import { toastEventDispatch } from '@space-lib-events/toast'
import { ToastPosition, ToastType } from '@space-lib-events/toast/enum'
import i18n from 'src/i18n'
import { useParams } from 'react-router-dom'
import { useDeviceInfo } from '@hotmart-org-ca/space-lib/dist/hooks'
import { useSendDatahubDefaultEvents } from 'src/hook/useSendDatahubDefaultEvents'
import {
  Action,
  ComponentName,
  ComponentSource,
  Entity,
  FailureDescription,
  System,
  TryResult
} from 'src/utils/datahubDefaultEvent'
import { CommunityTypeConsume } from 'src/pages/communityHome'
import { useCommunityDetails } from 'src/pages/CommunityDetails/Posts/context/communityDetailsContext'
import { useCustomEvent } from 'src/hook/useCustomEvent'
import { FeedEventNames } from 'src/hook/usePosts'
import useEditPostModalMutation from '../useEditPostModalMutation/useEditPostModalMutation'
import { UseEditPostSubmitProps } from './useEditPostSubmit.types'

const useEditPostSubmit = () => {
  const { dispatchDatahubDefaultEvents } = useSendDatahubDefaultEvents()
  const deviceInfo = useDeviceInfo()
  const {
    community: { type }
  } = useCommunityDetails()
  const { mutate: editPostMutation, isLoading } = useEditPostModalMutation()
  const { idCommunity } = useParams()
  const { emitEvent } = useCustomEvent()

  const handleSubmit = ({
    title,
    description,
    postId,
    isPinnedPost,
    onClose,
    isScheduledPosts
  }: UseEditPostSubmitProps) => {
    editPostMutation(
      {
        title,
        description,
        postId
      },
      {
        onSuccess: () => {
          dispatchDatahubDefaultEvents({
            system: System.HOTMART_CLUB,
            action: Action.TRY_TO_EDIT_POST,
            entity: Entity.COMMUNITY,
            event: {
              communityId: Number(idCommunity),
              communityType: CommunityTypeConsume[type],
              componentName: ComponentName.EDIT_POST_MODAL,
              componentSource: ComponentSource.POST_LIST,
              screenName: ComponentName.POST_FEED,
              result: TryResult.SUCCESSFUL,
              statusCode: 200,
              hasAccessToTheCommunity: true,
              failureDescription: FailureDescription.NOT_FAILURE_RESULT_EVENT,
              ...deviceInfo
            }
          })

          onClose()
          toastEventDispatch({
            type: ToastType.SUCCESS,
            message: i18n.t('edit_post.success_toast'),
            position: ToastPosition.BOTTOM_RIGHT
          })

          emitEvent(FeedEventNames.POST_UPDATED, {
            postId,
            isPinnedPost,
            isScheduledPosts
          })
        },
        onError: (error) => {
          dispatchDatahubDefaultEvents({
            system: System.HOTMART_CLUB,
            action: Action.TRY_TO_EDIT_POST,
            entity: Entity.COMMUNITY,
            event: {
              communityId: Number(idCommunity),
              communityType: CommunityTypeConsume[type],
              componentName: ComponentName.EDIT_POST_MODAL,
              componentSource: ComponentSource.POST_LIST,
              screenName: ComponentName.POST_FEED,
              result: TryResult.FAILURE,
              statusCode: error?.statusCode,
              hasAccessToTheCommunity: true,
              failureDescription: error?.message ?? FailureDescription.NO_MESSAGE,
              ...deviceInfo
            }
          })

          toastEventDispatch({
            type: ToastType.DANGER,
            message: i18n.t('edit_post.error_toast'),
            position: ToastPosition.BOTTOM_RIGHT
          })
        }
      }
    )
  }

  return { handleSubmit, isLoading }
}

export default useEditPostSubmit
